import { computed, ref }           from "vue";
import { createClient }            from "@supabase/supabase-js";
import Analytics                   from "src/composables/Analytics";
import { LocalStorage }            from "quasar";
import { cp_bg_c_cart_2025_02_03 } from "src/composables/Cart";

const supabaseUrl = process.env.SUPABASE_URL;
const supabaseAnonKey = process.env.SUPABASE_ANON_KEY;

const supabase = createClient(supabaseUrl, supabaseAnonKey)

const maxAge = 100 * 365 * 24 * 60 * 60 // 100 years, never expires
const expires = new Date(0).toUTCString()
const { log_event } = Analytics()

supabase.auth.onAuthStateChange((event, session) => {
  switch (event) {
    case 'SIGNED_IN':
      const user_information = {}
      if (user.value) {
        const { id, user_metadata, last_sign_in_at } = user.value
        const { email, HMAC } = user_metadata || {}
        user_information.user_id = id
        user_information.logged_in_at = Math.round(new Date(last_sign_in_at).getTime() / 1000)
        user_information.email = email
        user_information.cp_fpid = LocalStorage.getItem('cp_fpid')
        if (user_information.cp_fpid) {
          user_information.cp_fpid_only = user_information.cp_fpid.split('.')[0]
          user_information.cp_fpid_timestamp = user_information.cp_fpid.split('.')[1]
        }
        if (HMAC) {
          user_information.intercom_hmac_hash = HMAC
        }
        cp_bg_c_cart_2025_02_03.value.user_details = { ...cp_bg_c_cart_2025_02_03.value.user_details, ...user_information }
      }
      log_event({
        name: 'auth_event',
        user_information: user_information,
        mem_event_details: {
          auth_event_type: 'load_authenticated'
        },
        cp_cart: cp_bg_c_cart_2025_02_03.value
      })
    case 'TOKEN_REFRESHED':
      document.cookie = `my-access-token=${ session.access_token }; Domain=${ process.env.AUTH_DOMAIN }; path=/; max-age=${ maxAge }; SameSite=Lax; secure`
      document.cookie = `my-refresh-token=${ session.refresh_token }; Domain=${ process.env.AUTH_DOMAIN }; path=/; max-age=${ maxAge }; SameSite=Lax; secure`
      is_authenticated.value = true
      user.value = session.user
      break
    case 'USER_UPDATED':
      user.value = session.user
      break
    case 'SIGNED_OUT':
      document.cookie = `my-access-token=; Domain=${ process.env.AUTH_DOMAIN }; path=/; expires=${ expires }; SameSite=Lax; secure`
      document.cookie = `my-refresh-token=; Domain=${ process.env.AUTH_DOMAIN }; path=/; expires=${ expires }; SameSite=Lax; secure`
      is_authenticated.value = false
      user.value = null
      log_event({ name: 'auth_event', mem_event_details: { auth_event_type: 'successful_sign_out' } })
      // window.location.reload()
      break
  }
})

const is_authenticated = ref(false)
const user = ref(null)
const picture = computed(() => {
  if (user.value) {
    if (user.value.user_metadata?.first_name && user.value.user_metadata?.last_name) {
      return `https://ui-avatars.com/api/?background=03a9f4&color=fff&name=${ user.value.user_metadata.first_name }+${ user.value.user_metadata.last_name }`
    }
    if (user.value.email) {
      return `https://ui-avatars.com/api/?background=03a9f4&color=fff&name=${ user.value.email }`
    }
    if (user.value.phone) {
      return `https://ui-avatars.com/api/?background=03a9f4&color=fff&name=${ user.value.phone }`
    }
    return `https://ui-avatars.com/api/?name=${ user.value.id }`
  }
  return null
})

export default () => {
  return {
    supabase,
    is_authenticated,
    user,
    picture,
  }
}
